import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c9b928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-list" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}

import {} from 'vue'
import { Button, ImagePreview } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'special-agreement',
  setup(__props) {

const imgList: string[] = []
for (let i = 0; i < 11; i++) {
  imgList.push(`https://static.knowledge.xag.cn/img/jijia-special-agreement/${i + 1}.jpeg`)
}

const $router = useRouter()

function previewHandle(index: number) {
  ImagePreview({
    images: imgList,
    startPosition: index,
  })
}
function back() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "授权条款" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgList, (item, index) => {
        return _createElementVNode("img", {
          src: item,
          alt: "",
          key: index,
          onClick: ($event: any) => (previewHandle(index))
        }, null, 8, _hoisted_2)
      }), 64))
    ]),
    (_ctx.isShowFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Button), {
            block: "",
            type: "success",
            class: "xa-vant-button",
            onClick: back
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})